export {
  FontStyle,
  FontType,
  FontWeight,
  TextAlign,
  TextComponent,
  TextSize,
  TextTransform,
} from './text.component';

export { FontColor, ReadMore } from './text.model';
